import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/zh-cn/services/pharmacovigilance/regulatory-intelligence")({
  head: () => buildRouteHead("/zh-cn/services/pharmacovigilance/regulatory-intelligence"),
  component: PVOffering,
});

